import Marquee from "react-fast-marquee";
import { Sprout } from "lucide-react";

const words = ["Office Cleaning", "Retail & Food-Service", "Industrial & Factory", "Contract Cleaning", "Deep Cleaning"];

export default function MarqueeStrip() {
    return (
        <div className="bg-sage text-forest py-6 border-y border-edge" data-testid="marquee-strip">
            <Marquee speed={35} gradient={false}>
                {words.map((w) => (
                    <span key={w} className="flex items-center gap-10 mx-10">
                        <span className="font-serif italic text-xl md:text-2xl whitespace-nowrap">{w}</span>
                        <Sprout className="w-5 h-5 shrink-0" strokeWidth={1.5} />
                    </span>
                ))}
            </Marquee>
        </div>
    );
}
